import { useEffect, memo } from 'react';
import { v4 as uuidv4 } from 'uuid';

const CalendlyWidget = memo(({ url, gettingFullResponse, config }: { 
    url: string, 
    gettingFullResponse: boolean,
    config: any 
}) => {
    const hexToRgb = (hex: string) => {
        hex = hex.replace(/^#/, '');
        let bigint = parseInt(hex, 16);
        let r = (bigint >> 16) & 255;
        let g = (bigint >> 8) & 255;
        let b = bigint & 255;
        return `${r}, ${g}, ${b}`;
    };

    useEffect(() => {
        if (!gettingFullResponse) {
            const loadScript = () => {
                const existingScript = document.getElementById('calendly-script');
                if (existingScript) {
                    document.body.removeChild(existingScript);
                }
                const script = document.createElement('script');
                script.id = 'calendly-script';
                script.src = 'https://assets.calendly.com/assets/external/widget.js';
                script.async = true;
                document.body.appendChild(script);
            };

            loadScript();

            return () => {
                // Cleanup if needed, though generally we might not need to remove the script
            };
        }
    }, [gettingFullResponse]); 

    const uuid = uuidv4();
    const uniqueId = `calendly-widget-${uuid}`;

    if (gettingFullResponse) {
        return (
            <div className="flex items-center justify-center my-4">
                <div className="flex items-center space-x-2 my-2 p-2 rounded-lg"
                    style={{
                        backgroundColor: `rgba(${hexToRgb(config.color)}, 0.03)`,
                        border: `1px solid rgba(${hexToRgb(config.color)}, 0.1)`,
                        color: `rgba(${hexToRgb(config.color)}, 0.7)`
                    }}
                >
                    <div className="inline-flex items-center">
                        <svg className="animate-spin -ml-1 mr-2 h-4 w-4" 
                            xmlns="http://www.w3.org/2000/svg" 
                            fill="none" 
                            viewBox="0 0 24 24"
                            style={{
                                color: `rgba(${hexToRgb(config.color)}, 0.7)`
                            }}
                        >
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Loading calendar...
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div 
            id={uniqueId} 
            className={`calendly-inline-widget min-w-[200px] h-[1000px]`} 
            data-url={`${url}`}
        />
    );
});

export default CalendlyWidget;